import * as React from "react";


import {
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    required,
    ArrayInput,
    SimpleFormIterator,
    BooleanInput,
    PasswordInput,
    email,
    useNotify,
    useRefresh,
    useRedirect,
    
   
} from "react-admin";

import { Container } from "../../assets/styled-components/Container";
import "../../assets/styles/form.css";

const validateEmail = [email(), required()];

const validateUserUpdate = (values) => {
    const errors = {};
    if (values.password !== values.confirmPassword) {
        errors.password = "Passwords do not match";
        errors.confirmPassword = "Passwords do not match";
    }

    return errors;
};




const ShowTitle = ({ record }) => {
    return <span> {record ? `${record.userName}` : ""}</span>;
};






export const UserEdit = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify(`Changes saved`);
        redirect("/users");
        refresh();
    };

    return (
        <Edit title={<ShowTitle />}  {...props}>
            <SimpleForm validate={validateUserUpdate} >
                <Container>
                    <div className="left-container">
                        <h2>Identity</h2>
                        <div className="identity-2">
                            <TextInput fullWidth={true} label="userName" source="userName" resettable />
                            <TextInput fullWidth={true} label="mobileNumber" source="mobileNumber" resettable />
                        </div>

                        <div className="row">
                            <TextInput fullWidth={true} label="email" source="email" resettable validate={validateEmail} />
                        </div>

                        <div className="row">
                            <h2>Address</h2>
                            <TextInput fullWidth={true} label="address1" source="address1" resettable />
                            <div className="row">
                                <TextInput fullWidth={true} label="address2" source="address2" resettable />
                            </div>
                            <div className="row address-3">
                                <TextInput fullWidth={true} label="city" source="city" resettable />
                                <TextInput fullWidth={true} label="state" source="state" resettable />
                                <NumberInput fullWidth={true} label="zipCode" source="zipCode" resettable />
                            </div>
                        </div>

                        <div className="row">
                            <h2>Store</h2>
                            <div className="store-3">
                                <TextInput fullWidth={true} label="storeName" source="storeName" resettable />
                                <NumberInput fullWidth={true} label="rate" source="rate" resettable />
                                <NumberInput fullWidth={true} label="numberOfUsersRated" source="numberOfUsersRated" resettable />
                            </div>
                        </div>
                        <div className="row">
                            <BooleanInput label="is Provide Staging" source="isProvideStaging" />
                        </div>
                        <div className="row">
                            <h2>Enter Password</h2>
                            <div className="store-3">
                                <PasswordInput fullWidth={true} label="Password" source="password" />
                                <PasswordInput fullWidth={true} label="Confirm Password" source="confirmPassword" />
                            </div>
                        </div>
                    </div>
                    <div className="right-container">
                        <div className="operation-content">
                            <ArrayInput source="userOperationLocation">
                                <SimpleFormIterator>
                                    <NumberInput label="zipCode" source="zipCode" />
                                    <NumberInput label="radius" source="radius" />
                                </SimpleFormIterator>
                            </ArrayInput>
                        </div>
                    </div>
                </Container>
            </SimpleForm>
        </Edit>
    );
};